const applicationHistories = [
    {
        "uuid": "1",
        "customerNo": "0001",
        "customerName": "源天然股份有限公司",
        "appNo": "A18080101",
        "appType": "initial",
        "projectManager": "陳阿鼠",
        "handler": "王阿牛",
        "appStayDays": 2,
        "appProgress": "close",
        "confirmStatement": true,
        "documentReviewContent": [
            {"nodeId":"1_assessmentProduct", "category":"評鑑產品","item":"杏仁玄米餅","subItem":"豆蓉粉(新版)", "comments":"原料H-牛蒡片005(牛蒡片)(使用於成品黑豆牛蒡茶、牛蒡養生茶、人參黃耆茶、黑豆牛蒡茶包)\n" +
                    "(1)檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明。\n" +
                    "(2)所提供之外標示照片無供應商及製造商可與明細表長昇蔘藥行有限公司勾稽，請重新提供標示照片(或提供進貨單據)",
                "completedDate":"2021-07-21T08:20:10.000Z",
                "reviewHistories":[
                    {"reviewDate":"2021-07-12T08:20:10.000Z","reviewComments":"檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"},
                    {"reviewDate":"2021-07-18T08:20:10.000Z","reviewComments":"所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽","supplementDate":"2021-07-20T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"}
                ]},
            {"nodeId":"4_assessmentProduct", "category":"評鑑產品","item":"Natural Benefits 食安生技-椰子汁", "comments":"1.跟零食一樣爽脆、熱量只有1/20！吃西洋芹紓壓解熱還能補足多種營養 2.請附輸入食品許可通知",
                "reviewHistories":[
                    {"reviewDate":"2021-07-12T08:20:10.000Z","reviewComments":"檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true,"supplementedDesc":"已根據要求說明"},
                    {"reviewDate":"2021-07-18T08:20:10.000Z","reviewComments":"所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true}
                ]}
        ],
        "inspectionNCRs": [
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "ncImprovementMethod":"online",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "confirmDate": "2021-08-05T00:00:00.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "ncImprovementMethod":"online",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "confirmDate": "2021-08-05T00:00:00.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-03",
                "ncrType":"secondary",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "ncImprovementMethod":"online",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "confirmDate": "2021-08-05T00:00:00.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-04",
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "ncImprovementMethod":"online",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "confirmDate": "2021-08-05T00:00:00.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            }
        ],
    },
    {
        "uuid": "4",
        "customerNo": "0001",
        "customerName": "源天然股份有限公司",
        "appNo": "A21010101",
        "appType": "renewal",
        "phase": "inspectionArrangement",
        "activity": "inspectionArrangement_S10",
        "projectManager": "馬阿馬",
        "handler": "蔡阿羊",
        "appStayDays": 16,
        "appProgress": "normal",
        "confirmStatement": true,
        "productionLineRemoves": [
            {
                "productionLine": "果汁線",
                "removes":[
                    {
                        "name": "Natural Benefits 食安生技-椰子汁",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "250ml/包",
                        "channel": ["leezen"],
                        "backEndName": "食安生技-椰子汁",
                        "status": "approve",
                        "agree": true,
                    },
                    {
                        "name": "Natural Benefits 食安生技-椰子汁",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "360ml/包",
                        "channel": ["leezen"],
                        "backEndName": "食安生技-椰子汁",
                        "status": "improvement",
                    },
                    {
                        "name": "atural Benefits 純在葡萄柚蘋果綠茶",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "250ml/包",
                        "channel": ["leezen"],
                        "backEndName": "純在葡萄柚蘋果綠茶",
                        "status": "suspend",
                        "agree": true,
                    },
                    {
                        "name": "atural Benefits 純在葡萄柚蘋果綠茶",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "360ml/包",
                        "channel": ["leezen"],
                        "backEndName": "純在葡萄柚蘋果綠茶",
                        "status": "approve",
                        "agree": true,
                    },
                ]
            },
            {
                "productionLine": "飲料線",
                "removes":[
                    {
                        "name": "桂圓四物飲",
                        "tseyueLevel": "",
                        "leezenLevel": "organic",
                        "productionLine": "飲料線",
                        "processStatus": "backEnd",
                        "packaging": "glassBottle",
                        "spec": "360ml/瓶",
                        "channel": ["leezen", "family"],
                        "status": "approve",
                        "agree": true,
                    },
                    {
                        "name": "桂圓四物飲",
                        "tseyueLevel": "",
                        "leezenLevel": "organic",
                        "productionLine": "飲料線",
                        "processStatus": "backEnd",
                        "packaging": "glassBottle",
                        "spec": "1000ml/瓶",
                        "channel": ["leezen", "family"],
                        "status": "approve",
                        "agree": true,
                    },
                ]
            },
            {
                "productionLine": "餅乾線",
                "removes":[
                    {
                        "name": "杏仁玄米餅",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "餅乾線",
                        "processStatus": "backEnd",
                        "packaging": "paperBag",
                        "spec": "200/盒",
                        "channel": ["leezen"],
                        "status": "approve",
                        "agree": true,
                    },
                ]
            },
        ],
        "productAttachmentOverdueList": [
            {
                "product": "杏仁玄米餅",
                "attachmentType": "productInspectionReport",
                "filenameOld": "檔案11.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "報告日期",
                "validDateNew": "2021-11-11T08:00:00.000Z",
                "reviewResult": "qualified",
                "history": [
                    {
                        "reviewResult": "unQualified",
                        "replyDate": "2022-01-25T11:38:00.000Z",
                        "supplementDesc": "補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明",
                        "customerDesc": "客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明",
                    },
                ]
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "productInspectionReport",
                "filenameOld": "檔案12.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "報告日期",
                "validDateNew": "2021-11-11T08:00:00.000Z",
                "reviewResult": "unQualified",
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "importOrganicConsentDoc",
                "filenameOld": "檔案21.pdf",
                "validDateOld": "2021-11-20T08:00:00.000Z",
                "dateType": "文件日期",
                "validDateNew": "2021-12-20T08:00:00.000Z",
                "reviewResult": "noNeedToTrack",
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "enterFoodPermissionNotice",
                "filenameOld": "檔案31.pdf",
                "validDateOld": "2021-09-30T08:00:00.000Z",
                "dateType": "報告日期",
                "validDateNew": "2021-10-30T08:00:00.000Z",
                "reviewResult": "qualified",
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "alcoholContentTestReport",
                "filenameOld": "檔案41.pdf",
                "validDateOld": "2021-12-09T08:00:00.000Z",
                "dateType": "報告日期",
                "validDateNew": "2022-01-09T08:00:00.000Z",
                "reviewResult": "qualified",
            },
            {
                "product": "桂圓四物飲",
                "attachmentType": "importOrganicConsentDoc",
                "filenameOld": "檔案51.pdf",
                "validDateOld": "2021-12-05T08:00:00.000Z",
                "dateType": "文件日期",
                "validDateNew": "2022-01-05T08:00:00.000Z",
                "reviewResult": "qualified",
            },
        ],
        "rawMaterialAttachmentOverdueList": [
            {
                "rawMaterial": "豆蓉粉",
                "product": "杏仁玄米餅",
                "attachmentType": "inspectionReport",
                "filenameOld": "檔案11.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "報告日期",
                "type":"material",
                "storageCondition":"roomTemperature",
                "composition":"",
                "domesticVendor":"穎昌食品有限公司(新和美)",
                "importer":"",
                "manufacturer":"穎昌食品有限公司(新和美)",
                "originPlace":"台灣",
                "additiveLicenseNumber":"",
                "addRatio":9,
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":1,
                "relatedDocuments":[
                    {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                    {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                ],
                "validDateNew": "2021-12-01T08:00:00.000Z",
                "description": "說明......",
                "reviewResult": "qualified",
                "history": [
                    {
                        "reviewResult": "unQualified",
                        "replyDate": "2022-01-25T11:38:00.000Z",
                        "supplementDesc": "補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明",
                        "customerDesc": "客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明",
                    },
                ]
            },
            {
                "rawMaterial": "美國加州杏仁果",
                "product": "杏仁玄米餅、杏仁巧克力酥",
                "attachmentType": "foodAdditiveLicense",
                "filenameOld": "檔案12.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "有效日期",
                "type":"material",
                "storageCondition":"roomTemperature",
                "domesticVendor":"信成股份有限公司",
                "importer":"信成股份有限公司",
                "manufacturer":"TERRA NOVA TRADING INC.",
                "originPlace":"美國",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":2,
                "validDateNew": "2021-12-01T08:00:00.000Z",
                "description": "說明......",
                "reviewResult": "qualified",
            },
            {
                "rawMaterial": "有機生糙米粉(台灣)",
                "product": "杏仁巧克力酥",
                "attachmentType": "enterFoodPermissionNotice",
                "filenameOld": "檔案21.pdf",
                "validDateOld": "2021-11-20T08:00:00.000Z",
                "dateType": "進口日期",
                "storageCondition":"refrigeration",
                "domesticVendor":"青田農產有限公司",
                "importer":"",
                "manufacturer":"青田農產有限公司",
                "originPlace":"台灣",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":8,
                "validDateNew": "2022-01-20T08:00:00.000Z",
                "description": "說明......",
                "reviewResult": "qualified",
            },
            {
                "rawMaterial": "甜扁桃仁粒",
                "product": "杏仁玄米餅",
                "attachmentType": "importOrganicConsentDoc",
                "filenameOld": "檔案31.pdf",
                "validDateOld": "2021-09-30T08:00:00.000Z",
                "dateType": "有效日期",
                "storageCondition":"refrigeration",
                "domesticVendor":"成久旺股份有限公司",
                "importer":"成久旺股份有限公司",
                "manufacturer":"TWIN COMMODITIES,INC.",
                "originPlace":"美國",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":6,
                "validDateNew": "2021-11-30T08:00:00.000Z",
                "description": "說明......",
                "disable": true,
                "agree": true,
                "reviewResult": "qualified",
            },
            {
                "rawMaterial": "杏仁粉(細)",
                "product": "杏仁玄米餅",
                "attachmentType": "organicCertificate",
                "filenameOld": "檔案41.pdf",
                "validDateOld": "2021-12-09T08:00:00.000Z",
                "dateType": "有效日期",
                "storageCondition":"roomTemperature",
                "domesticVendor":"成久旺股份有限公司",
                "importer":"成久旺股份有限公司",
                "manufacturer":"Treehouse California Almonds LLC",
                "originPlace":"美國",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":11,
                "validDateNew": "2022-02-09T08:00:00.000Z",
                "description": "說明......",
                "reviewResult": "qualified",
            },
        ],
        "documentReviewContent": [
            {"nodeId":"1_assessmentProduct", "category":"評鑑產品","item":"杏仁玄米餅","subItem":"豆蓉粉(新版)", "comments":"原料H-牛蒡片005(牛蒡片)(使用於成品黑豆牛蒡茶、牛蒡養生茶、人參黃耆茶、黑豆牛蒡茶包)\n" +
                    "(1)檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明。\n" +
                    "(2)所提供之外標示照片無供應商及製造商可與明細表長昇蔘藥行有限公司勾稽，請重新提供標示照片(或提供進貨單據)",
                "completedDate":"2021-07-21T08:20:10.000Z",
                "reviewHistories":[
                    {"reviewDate":"2021-07-12T08:20:10.000Z","reviewComments":"檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"},
                    {"reviewDate":"2021-07-18T08:20:10.000Z","reviewComments":"所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽","supplementDate":"2021-07-20T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"}
                ]},
            {"nodeId":"4_assessmentProduct", "category":"評鑑產品","item":"Natural Benefits 食安生技-椰子汁", "comments":"1.跟零食一樣爽脆、熱量只有1/20！吃西洋芹紓壓解熱還能補足多種營養 2.請附輸入食品許可通知",
                "reviewHistories":[
                    {"reviewDate":"2021-07-12T08:20:10.000Z","reviewComments":"檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true,"supplementedDesc":"已根據要求說明"},
                    {"reviewDate":"2021-07-18T08:20:10.000Z","reviewComments":"所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true}
                ]}
        ],
        "inspectionNCRs": [
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "ncImprovementMethod":"online",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "confirmDate": "2021-08-05T00:00:00.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "ncImprovementMethod":"online",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "confirmDate": "2021-08-05T00:00:00.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-03",
                "ncrType":"secondary",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "ncImprovementMethod":"online",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "confirmDate": "2021-08-05T00:00:00.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-04",
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "ncImprovementMethod":"online",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ],
                "correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍",
                "estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "confirmDate": "2021-08-05T00:00:00.000Z",
                "evaluateCorrectiveAction":"agree",
                "evaluationContent":"確認已修改完成",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            }
        ],
    },
    {
        "uuid": "7",
        "appNo": "21080101",
        "appType": "markReview",
        "phase": "markReview",
        "activity": "markReview_S10",
        "customerNo": "0001",
        "customerName": "中農粉絲有限公司",
        "projectManager": "李阿白",
        "handler": "陳阿明",
        "appStayDays": 8,
        "appProgress": "normal",
        "assignee": "王大大",
        "reviewResult": "",
        "applicationDate": "2021-12-17T22:15:00.000Z",
        "companyAddress": "新北市土城區藍天街7巷7號7樓",
        "companyPhone": "02-8967-6666",
        "markReviewProducts": [
            {
                "product": "Natural Benefits 食安生技-椰子汁",
                "packagingMethod": "tinplateCan",
                "spec": "360ml/罐",
                "tseyueLevel": "clean",
                "channel": "leezen",
                "productType": "general",
                "changeDesc": "異動說明............",
                "reviewItems": [
                    {"item": "productName", "agree": true},
                    {"item": "content", "agree": true},
                    {"item": "spec", "agree": true},
                    {"item": "customerName", "agree": true},
                    {"item": "address", "agree": true},
                    {"item": "phone", "agree": true},
                    {"item": "markLevel", "agree": true},
                    {"item": "otherAppeals", "agree": true},
                ],
                "markFileAgreements": [
                    {
                        "fileName": "0190222_FMC新鮮屋_特濃黑可可-滿版-01.pdf", "agree": true
                    },
                    {
                        "fileName": "20190222_FMC新鮮屋_特濃黑可可-滿版-02.pdf", "agree": true
                    },
                ],
                "reviewResult": "agree",
                "reviewSupplementHistory": [
                    {
                        "reviewDate": "2021-10-01T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-10-08T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                    {
                        "reviewDate": "2021-11-04T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-11-11T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                ],
                "rawMaterials": [
                    {
                        "id":"1",
                        "type":"material",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)"
                    },
                    {
                        "id":"2",
                        "type":"material",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "composition":"樹薯澱粉、水(原料)",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2,
                        "validityAndSituation":"有效日期：2023/04/18"
                    },
                    {
                        "id":"3",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3,
                        "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                            "當天使用有效日期2021.11.17(8/17進貨)"
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                    {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ],
            },
            {
                "product": "Natural Benefits 純在-蔬菜綜合果汁",
                "packagingMethod": "glassBottle",
                "spec": "360ml/瓶",
                "tseyueLevel": "clean",
                "channel": "leezen",
                "productType": "general",
                "changeDesc": "異動說明............",
                "reviewItems": [
                    {"item": "productName", "agree": true},
                    {"item": "content", "agree": true},
                    {"item": "spec", "agree": true},
                    {"item": "customerName", "agree": true},
                    {"item": "address", "agree": true},
                    {"item": "phone", "agree": true},
                    {"item": "markLevel", "agree": true},
                    {"item": "otherAppeals", "agree": true},
                ],
                "markFileAgreements": [
                    {
                        "fileName": "0190222_FMC新鮮屋_特濃黑可可-滿版-01.pdf", "agree": true
                    },
                    {
                        "fileName": "20190222_FMC新鮮屋_特濃黑可可-滿版-02.pdf", "agree": true
                    },
                ],
                "reviewResult": "agree",
                "reviewSupplementHistory": [
                    {
                        "reviewDate": "2021-10-01T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-10-08T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                    {
                        "reviewDate": "2021-11-04T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-11-11T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                ],
                "rawMaterials": [
                    {
                        "id":"1",
                        "type":"material",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)"
                    },
                    {
                        "id":"2",
                        "type":"material",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "composition":"樹薯澱粉、水(原料)",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2,
                        "validityAndSituation":"有效日期：2023/04/18"
                    },
                    {
                        "id":"3",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3,
                        "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                            "當天使用有效日期2021.11.17(8/17進貨)"
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                    {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ],
            },
        ],
    },
    {
        "uuid": "8",
        "createdOn": "2021-12-17T22:15:00.000Z",
        "appNo": "21080102",
        "appType": "markReview",
        "phase": "markReview",
        "activity": "markReview_S20",
        "customerNo": "0002",
        "customerName": "黑松股份有限公司",
        "projectManager": "張阿偉",
        "handler": "蔡阿豪",
        "appStayDays": 4,
        "appProgress": "normal",
        "assignee": "李小小",
        "companyAddress": "新北市土城區藍天街7巷7號7樓",
        "companyPhone": "02-8967-6666",
        "markReviewProducts": [
            {
                "product": "Natural Benefits 食安生技-椰子汁",
                "packagingMethod": "tinplateCan",
                "spec": "360ml/罐",
                "tseyueLevel": "clean",
                "channel": "leezen",
                "productType": "general",
                "changeDesc": "異動說明............",
                "reviewItems": [
                    {"item": "productName", "agree": true},
                    {"item": "content", "agree": true},
                    {"item": "spec", "agree": true},
                    {"item": "customerName", "agree": true},
                    {"item": "address", "agree": true},
                    {"item": "phone", "agree": true},
                    {"item": "markLevel", "agree": true},
                    {"item": "otherAppeals", "agree": true},
                ],
                "markFileAgreements": [
                    {
                        "fileName": "0190222_FMC新鮮屋_特濃黑可可-滿版-01.pdf", "agree": true
                    },
                    {
                        "fileName": "20190222_FMC新鮮屋_特濃黑可可-滿版-02.pdf", "agree": true
                    },
                ],
                "reviewResult": "agree",
                "reviewSupplementHistory": [
                    {
                        "reviewDate": "2021-10-01T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-10-08T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                    {
                        "reviewDate": "2021-11-04T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-11-11T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                ],
                "rawMaterials": [
                    {
                        "id":"1",
                        "type":"material",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)"
                    },
                    {
                        "id":"2",
                        "type":"material",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "composition":"樹薯澱粉、水(原料)",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2,
                        "validityAndSituation":"有效日期：2023/04/18"
                    },
                    {
                        "id":"3",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3,
                        "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                            "當天使用有效日期2021.11.17(8/17進貨)"
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                    {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ],
            },
            {
                "product": "Natural Benefits 純在-蔬菜綜合果汁",
                "packagingMethod": "glassBottle",
                "spec": "360ml/瓶",
                "tseyueLevel": "clean",
                "channel": "leezen",
                "productType": "general",
                "changeDesc": "異動說明............",
                "reviewItems": [
                    {"item": "productName", "agree": true},
                    {"item": "content", "agree": true},
                    {"item": "spec", "agree": true},
                    {"item": "customerName", "agree": true},
                    {"item": "address", "agree": true},
                    {"item": "phone", "agree": true},
                    {"item": "markLevel", "agree": true},
                    {"item": "otherAppeals", "agree": true},
                ],
                "markFileAgreements": [
                    {
                        "fileName": "0190222_FMC新鮮屋_特濃黑可可-滿版-01.pdf", "agree": true
                    },
                    {
                        "fileName": "20190222_FMC新鮮屋_特濃黑可可-滿版-02.pdf", "agree": true
                    },
                ],
                "reviewResult": "agree",
                "reviewSupplementHistory": [
                    {
                        "reviewDate": "2021-10-01T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-10-08T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                    {
                        "reviewDate": "2021-11-04T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-11-11T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                ],
                "rawMaterials": [
                    {
                        "id":"1",
                        "type":"material",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)"
                    },
                    {
                        "id":"2",
                        "type":"material",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "composition":"樹薯澱粉、水(原料)",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2,
                        "validityAndSituation":"有效日期：2023/04/18"
                    },
                    {
                        "id":"3",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3,
                        "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                            "當天使用有效日期2021.11.17(8/17進貨)"
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                    {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ],
            },
        ],
    },
]

export default applicationHistories;